var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{attrs:{"size":"3em"}},[_c('q-img',{attrs:{"src":"/statics/images/logo.svg","spinner-color":"blue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }